import React from 'react';
import Button from "@material-ui/core/Button";
import {linkDiscord} from "../../../store/coreSlice";
import {connect} from "react-redux";
import {getBasePath} from "../../../utils";

const LinkDiscordButton = (props) => {
	const onClickButton = () => {
		const now = new Date();
		now.setTime(now.getTime() + 3600 * 100);
		document.cookie = "discordLinkRedirect=" + (getBasePath()) + "; expires=" + now.toUTCString() + "; path=/";
		props.linkDiscord();
	};

	if( props.discordUser )
		return null;
	// 	return <div>Welcome, {props.discordUser}!</div>; // TODO: unlink

	return (<>
		<Button onClick={onClickButton}>
			Link Discord
		</Button>
	</>);
};

const mapStateToProps = (state) => {
	return {
		showSettings: state.core.showSettings,
		showTraffic: state.settings.showTraffic,
		useGps: state.settings.useGps,
		theme: state.settings.theme,
		discordUser: state.core.discordUser
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		linkDiscord: () => dispatch(linkDiscord())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkDiscordButton);